import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useRef, useEffect, isValidElement } from 'react';
export var ScrollTracking = function ScrollTracking(_ref) {
  var children = _ref.children,
    _ref$onScrollUp = _ref.onScrollUp,
    onScrollUp = _ref$onScrollUp === void 0 ? function () {} : _ref$onScrollUp,
    _ref$onScrollDown = _ref.onScrollDown,
    onScrollDown = _ref$onScrollDown === void 0 ? function () {} : _ref$onScrollDown,
    _ref$onHide = _ref.onHide,
    onHide = _ref$onHide === void 0 ? function () {} : _ref$onHide,
    _ref$onShow = _ref.onShow,
    onShow = _ref$onShow === void 0 ? function () {} : _ref$onShow;
  var attachTo = useRef(null);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    pageYOffset = _useState2[0],
    setPageYOffset = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    height = _useState4[0],
    setHeight = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    pageY = _useState6[0],
    setPageY = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    scrollingUp = _useState8[0],
    setScrollingUp = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    visible = _useState10[0],
    setVisible = _useState10[1];
  var updateCoordinates = function updateCoordinates() {
    if (attachTo !== null && attachTo !== void 0 && attachTo.current) {
      var _attachTo$current;
      var rect = attachTo === null || attachTo === void 0 ? void 0 : (_attachTo$current = attachTo.current) === null || _attachTo$current === void 0 ? void 0 : _attachTo$current.getBoundingClientRect();
      setPageY(rect.bottom);
      setHeight(rect.height);
    }
  };
  useEffect(function () {
    var updateOnScroll = function updateOnScroll() {
      if (window) {
        var pageYOffsetCurrent = window.pageYOffset;
        var pageYOffsetPrev = pageYOffset;
        if (pageYOffsetPrev && pageYOffsetPrev > pageYOffsetCurrent) {
          if (!scrollingUp) {
            setScrollingUp(true);
            onScrollUp();
          }
        } else if (scrollingUp && !visible) {
          setScrollingUp(false);
          onScrollDown();
        }
        setPageYOffset(pageYOffsetCurrent);
        updateCoordinates();
      }
    };
    updateCoordinates();
    if (window) {
      window.addEventListener('scroll', updateOnScroll);
    }
    return function () {
      if (window) {
        window.removeEventListener('scroll', updateOnScroll);
      }
    };
  }, [pageYOffset, onScrollUp, onScrollDown, scrollingUp, visible]);
  useEffect(function () {
    if (!height || !pageY) {
      updateCoordinates();
    }
    if (pageY) {
      if (pageY < 0) {
        if (!visible) {
          setVisible(true);
          onHide();
        }
      } else if (visible) {
        setVisible(false);
        onShow();
      }
    }
  }, [height, pageY, visible, onHide, onShow]);
  if (!children) {
    return null;
  }
  var child = React.Children.only(children);
  if ( /*#__PURE__*/isValidElement(child)) {
    return /*#__PURE__*/React.cloneElement(child, {
      ref: function ref(attachToRef) {
        attachTo.current = attachToRef;
      }
    });
  }
  return null;
};